import { Injectable, inject } from '@angular/core';
import { UkLocation } from '@shared/models';
import { FindAddressResponse, RetrieveAddressResponse } from '@shared/models/address';
import { Observable } from 'rxjs';
import { ClubHubDataService } from './clubhub-data.service';

@Injectable({
  providedIn: 'root',
})
export class AddressLookupService {
  private readonly clubHubDataService = inject(ClubHubDataService);

  public findAddress(searchTerm: string): Observable<FindAddressResponse[]> {
    return this.clubHubDataService.get<FindAddressResponse[]>(`Address/Find?searchTerm=${searchTerm}`);
  }

  public retrieveAddress(addressId: string) {
    return this.clubHubDataService.get<RetrieveAddressResponse>(`Address/Retrieve?addressId=${addressId}`, { loading: false });
  }

  public findPropertyRegion(postcode: string) {
    return this.clubHubDataService.get<UkLocation | null>(`Address/PropertyRegionSearch?postcode=${postcode}`, { loading: false });
  }
}
